import moment from 'moment'
import React, { ReactElement, useCallback } from 'react'

import { FeedbackBadge } from '../../../../../../../../../../1stlog-ui/src/components/Field'
import useFieldRaw from '../../../../../../../../../../1stlog-ui/src/components/Field/useFieldRaw'
import useFieldValue from '../../../../../../../../../../1stlog-ui/src/components/Field/useFieldValue'

type RecommendedTimeValidationProps = {}

export const RecommendedTimeValidation = (
  props: RecommendedTimeValidationProps,
): ReactElement => {
  const {} = props

  const recommendedTimeFrom = useFieldValue<string>('recommendedTimeFrom')
  const recommendedTimeUntil = useFieldValue<string>('recommendedTimeUntil')

  // Validation
  const validate = useCallback(() => {
    const from = moment(recommendedTimeFrom, 'HH:mm')
    const until = moment(recommendedTimeUntil, 'HH:mm')

    const min = moment('08:00', 'HH:mm')
    const max = moment('17:00', 'HH:mm')

    if (from.isBefore(min)) {
      return i18n.t(
        'recommended_time_validation_start_time_too_early',
        'Startzeit zu früh (frühestens 8 Uhr)',
      )
    }

    if (until.isAfter(max)) {
      return i18n.t(
        'recommended_time_validation_end_time_too_late',
        'Endzeit zu spät (spätestens 17 Uhr)',
      )
    }

    if (until.isBefore(from)) {
      return i18n.t(
        'recommended_time_validation_end_time_before_start_time',
        'Endzeit vor Startzeit',
      )
    }

    if (until.diff(from, 'hours') < 4) {
      return i18n.t(
        'recommended_time_validation_duration_too_short',
        'Dauer zu kurz (mind. 4 Stunden)',
      )
    }
  }, [recommendedTimeFrom, recommendedTimeUntil])

  const { meta: recommendedTimeMeta } = useFieldRaw(
    'recommendedTimeValidation',
    {
      subscribeAll: true,
      validate,
    },
  )

  return (
    <div>
      <FeedbackBadge meta={recommendedTimeMeta} alwaysDirty />
    </div>
  )
}
